import { Result, ResultEmpty } from '@headless-workspace/core-domain';
import { EcomConfigKeys } from './EcomConfigKeys';

const REQUIRED_ECOM_CONFIGS: EcomConfigKeys[] = [
    // EcomConfigKeys.BooxiApiKey,
    EcomConfigKeys.WoosmapApiKey,
    EcomConfigKeys.LoyaltyConfig,
    // EcomConfigKeys.EnableNewsletterBoostOptInOffer,
    EcomConfigKeys.ProductPriceShippingThreshold,
    EcomConfigKeys.EnablePriceLegalMentions,
    EcomConfigKeys.VipBrands,
    // EcomConfigKeys.EnableDeliveryToStore,
    // EcomConfigKeys.EnableNotifyMe,
    // EcomConfigKeys.RedDotConfig,
    EcomConfigKeys.T2SConfig,
    // EcomConfigKeys.OmnibusInformation,
    EcomConfigKeys.PromoStandardText,
];

const createEcomEmptyConfigs = (): Record<EcomConfigKeys, Result<unknown>> => {
    return Object.values(EcomConfigKeys).reduce(
        (acc, current) => {
            return {
                ...acc,
                [current]: ResultEmpty(),
            };
        },
        {} as Record<EcomConfigKeys, Result<unknown>>,
    );
};

const hasMissingRequiredConfigs = (configs: Record<EcomConfigKeys, Result<unknown>>): boolean =>
    REQUIRED_ECOM_CONFIGS.some(
        (requiredConfigKey) => !configs[requiredConfigKey] || configs[requiredConfigKey].type === 'failure',
    );

export const EcomConfigsHelpers = {
    createEcomEmptyConfigs,
    hasMissingRequiredConfigs,
};
